import React from "react"
import { Transformation } from "cloudinary-react"
import DfbButton from "../ui-kit/dfb_button"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbRte from "../ui-kit/dfb_rte"
import Section from "./section"

const MImagecarouselSpecial = (props) => {
  return (
    <Section
      baseClass="m-ImageCarousel m-ImageCarousel--special"
      className={props.className}
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-ImageCarousel-wrapper">
        <div className="m-ImageCarousel-container">
          {props.data.headline && (
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h4"
              add_class="m-ImageCarousel-headline"
            />
          )}
          <div className="m-ImageCarousel-carousel">
            {props.data.overline && (
              <span className="m-ImageCarousel-overline">
                {props.data.overline}
              </span>
            )}
            <div
              className="dfb-Slider dfb-Slider--special m-ImageCarousel-slider"
              data-transition="slide"
              data-loop
              data-indicators
              data-drag
              data-controls
              data-autoplay
              role="region"
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">
                  {props.data.items.map((item, index) => (
                    <li key={index} className="dfb-Slider-slideItem">
                      <a href={`${item.link}`}>
                        <figure className="m-ImageCarousel-figure">
                          <DfbImage image={item.image} aspect_ratio="16:9">
                            <Transformation
                              crop="fill"
                              gravity="faces:center"
                              width="720"
                              height="405"
                              quality="auto"
                              fetchFormat="auto"
                            />
                          </DfbImage>
                        </figure>
                      </a>
                      <div className="m-ImageCarousel-content">
                        {item.headline && (
                          <DfbHeadline
                            headline_level="h3"
                            headline={item.headline}
                          />
                        )}
                        {item.text && (
                          <div className="m-ImageCarousel-copy">
                            <DfbRte text={item.text} />
                          </div>
                        )}
                        {item.disclaimer && (
                          <span className="m-ImageCarousel-disclaimer">
                            {item.disclaimer}
                          </span>
                        )}
                        {item.link && (
                          <div className="m-ImageCarousel-button">
                            <DfbButton
                              tagName="a"
                              add_class="u-Theme-dark"
                              text={
                                item.link_obj?.title || props.defaultButtonText
                              }
                              link={item.link}
                            />
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <ul className="dfb-Slider-controls">
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Left"
                    add_class="dfb-Slider-control dfb-Slider-control--previous"
                  />
                </li>
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Right"
                    add_class="dfb-Slider-control dfb-Slider-control--next"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div className="m-ImageCarousel-navigation">
            {props.data.items.map((_, index) => (
              <div className="m-ImageCarousel-navigation-dot" key={index}></div>
            ))}
          </div>
          <div className="m-ImageCarousel-counter">
            <span className="m-ImageCarousel-index" />/
            <span className="m-ImageCarousel-slideCount" />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MImagecarouselSpecial
